import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import SimpleContent from "../../Structure/ModalManager/SimpleContent.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import Button from "../../Elements/Button/Button.js";

import "./FailedAPICommunication.scss";

const FailedAPICommunication = () => {
  const { getTextByKey } = useContent();

  return (
    <SimpleContent
      image={{ name: "paper-plane-crushed-circled", ext: "svg" }}
      title="communication-failed-title"
      message="communication-failed-text"
      actionButton={
        <LinkToNewTab page="support/a/internet-block">
          <Button>{getTextByKey("more-details")}</Button>
        </LinkToNewTab>
      }
    ></SimpleContent>
  );
};

export default FailedAPICommunication;
